import { render, staticRenderFns } from "./editdataelement.vue?vue&type=template&id=07906c48&"
import script from "../../ts/articleattributes/editdataelement.ts?vue&type=script&lang=js&"
export * from "../../ts/articleattributes/editdataelement.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports